import React from 'react';
import {BrowserRouter as Router, Switch, Redirect, Route} from 'react-router-dom';
import { createBrowserHistory } from 'history';
import routes from './routers';
import Public from './Public';
import Private from './Private';
import Register from '../containers/register'

const history = createBrowserHistory();

function RouterDom() {
	return (
        <Router history={history}>
            <Switch>
                <Redirect exact from='/' to='/home' />
                {routes.map((route) => {
                    if (route.auth) {
                        return <Private exact key={route.key} {...route} />;
                    }
                    return <Public exact key={route.key} {...route} />;
                })}
                <Route
                    component={Register}
                    exact
                    path='/register'
                />
                <Redirect to='/home' />
            </Switch>
        </Router>

    );
}

export default RouterDom;
